<template>
    <div v-if="isLoading" class="loading">
        <div>
            <i class="fad fa-circle-notch fa-4x fa-spin mt-5 mb-2"></i><br/>
            <span>Loading..</span>
        </div>
    </div>
</template>

<script>
    import loading from '@shared/mixins/loading';
    
    export default {
        props: ['loading'],
        mixins: [loading],
        data() {
            return {
                isLoading: (this.loading ? this.loading : false)
            }
        },
        created() {
            this.emitter.on('isLoading', data => {
                this.isLoading = data;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .loading {
        text-align: center;
        z-index: 99999;
        position: fixed;
        background: rgba(255,255,255,0.9);
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        div {
            position: absolute;
            top: 45%;
            width: 100%;
        }
    }
</style>